module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"startFromScratchLabel":"Start from scratch","startFromScratchText":"Don\u0027t want to start from a template?"}}')
  delete Component.options._Ctor
}
